'use client';

import { Container, Grid, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

import GlowingIcon from '@/components/GlowingIcon';
import PartnerLogo from '@/components/PartnerLogo';
import SectionTitle from '@/components/SectionTitle';
import Handshake from '@/components/SvgIcons/Handshake';
import { partners } from '@/config/partners.config';
import useBreakpoint from '@/utils/hooks/useBreakpoint';

import styles from './VerifiedBySection.module.scss';

const VerifiedBySection = () => {
  const t = useTranslations('home.verifiedBySection');
  const { isMobile } = useBreakpoint();

  return (
    <Container component="section" maxWidth="xl" className={styles.container}>
      <SectionTitle
        translationNamespace="home.verifiedBySection"
        translationKey="title"
        icon={
          <GlowingIcon>
            <Handshake />
          </GlowingIcon>
        }
      />
      <Grid container spacing={1} mt={8} justifyContent="center" className={styles.partners}>
        {partners.map(partner => (
          <Grid key={partner.id} size={{ xs: 2.4, lg: 1 }}>
            <PartnerLogo
              ColoredLogo={partner.Colored}
              NeutralLogo={partner.Neutral}
              size={isMobile ? 64 : 104}
              tooltipText={partner.name}
            />
          </Grid>
        ))}
      </Grid>
      <Typography variant="body1" textAlign="center" mt={{ xs: 6, md: 4 }} className={styles.description}>
        {t('description')}
      </Typography>
    </Container>
  );
};

export default VerifiedBySection;
